import React from 'react'

export default function Transformation() {
  return (
    <svg width="123" height="80" viewBox="0 0 123 80" fill="none" xmlns="http://www.w3.org/2000/svg" className='svg__animation'>
<mask id="path-1-inside-1_296_13" fill="white">
<path d="M0 10C0 4.47715 4.47715 0 10 0H112.667C118.19 0 122.667 4.47715 122.667 10V80H0V10Z"/>
</mask>
<path d="M-4 10C-4 2.26801 2.26801 -4 10 -4H112.667C120.399 -4 126.667 2.26801 126.667 10H118.667C118.667 6.68629 115.98 4 112.667 4H10C6.68629 4 4 6.68629 4 10H-4ZM122.667 80H0H122.667ZM-4 80V10C-4 2.26801 2.26801 -4 10 -4V4C6.68629 4 4 6.68629 4 10V80H-4ZM112.667 -4C120.399 -4 126.667 2.26801 126.667 10V80H118.667V10C118.667 6.68629 115.98 4 112.667 4V-4Z" fill="black" mask="url(#path-1-inside-1_296_13)"/>
<line x1="8" y1="71" x2="32" y2="71" stroke="black" stroke-width="4" className='path'/>
<line x1="8" y1="30" x2="60" y2="30" stroke="black" stroke-width="4"className='path'/>
<line x1="61" y1="71" x2="113" y2="71" stroke="black" stroke-width="4"className='path'/>
<line x1="66" y1="30" x2="113" y2="30" stroke="black" stroke-width="4"className='path'/>
<line x1="8" y1="57" x2="113" y2="57" stroke="black" stroke-width="4" className='path'/>
<path d="M8 45.6667L112.999 44.9867" stroke="black" stroke-width="4" className='path'/>
</svg>
  )
}
